"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var calendar = {
  fontFamily: _font["default"].family,
  fontSize: _font["default"].sizeSm,
  lineHeight: _font["default"].lineHeightXs,
  daySize: _size["default"].large,
  dayFontSize: _font["default"].sizeSm,
  dayColor: _color["default"].pickledBluewood800,
  daySelectedColor: _color["default"].white,
  dayPassiveColor: _color["default"].cloudyBlue,
  dayDisabledColor: _color["default"].cloudyBlue300,
  dayBackground: 'transparent',
  daySelectedBackground: _color["default"].dodgerBlue,
  daySelectedDisabledBackground: _color["default"].dodgerBlue300,
  dayPreviewBorderWidth: _size["default"].borderSizeDefault,
  dayPreviewBorderStyle: 'solid',
  dayPreviewBorderColor: _color["default"].dodgerBlue300,
  todayLineColor: _color["default"].dodgerBlue300,
  todaySelectedLineColor: _color["default"].white,
  todayLineWidth: _size["default"].default2x,
  todayLineHeight: _size["default"].smallest,
  weekDaysMarginBottom: _spacing["default"].xxs,
  weekDaysBorderWidth: _size["default"].borderSizeDefault,
  weekDaysBorderStyle: 'solid',
  weekDaysBorderColor: _color["default"].cloudyBlue300,
  weekDayColor: _color["default"].steel700,
  monthNameFontSize: _font["default"].sizeMd,
  monthNameLineHeight: _font["default"].lineHeightMd,
  monthNameFontWeight: _font["default"].weightAttention,
  calendarBackground: 'transparent',
  calendarHorizontalPadding: _spacing["default"].xs,
  calendarMonthYearPickerBottomMargin: _spacing["default"].lg,
  calendarMonthYearPickerVerticalPadding: _spacing["default"].sm,
  monthSeparatorLineWidth: '1px',
  monthSeparatorLineColor: _color["default"].cloudyBlue300,
  monthSeparatorLineMargin: _spacing["default"].md
};
var _default = calendar;
exports["default"] = _default;